import { useEffect, useState } from "react";
import style from "./DynamicTable.module.css";

function DynamicTable({ fetchedData }) {
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        if (fetchedData) {
            
            setTableData(fetchedData);
        }
    }, [fetchedData]);

    return (
        <div className={style.tableContainer}>
            <table className={style.table}>
                <thead>
                    <tr>
                        <th>No.</th>
                        <th>Image</th>
                        <th>상품명</th>
                        <th>판매갯수</th>
                        <th>총 판매금액</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((item, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                                {item.productImg ? (
                                    <img src={item.productImg} alt={item.productName} className={style.img} />
                                ) : (
                                    'No image'
                                )}
                            </td>
                            <td>{item.productName}</td>
                            <td>{item.totalQuantity}</td>
                            <td>{item.price ? ((item.totalQuantity) * (item.price)).toLocaleString() : 0}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default DynamicTable;